const baseColorRepository = color => {
  // 受け取る値が変わった場合には、name の方も変更すること
  const { base1, base1Selected, base2, base3, cancelButton, okButton } = color
  return {
    base1,
    base1Selected,
    base2,
    base3,
    cancelButton,
    okButton,
  }
}

export const name = {
  base1: 'base1',
  base1Selected: 'base1Selected',
  base2: 'base2',
  base3: 'base3',
  cancelButton: 'cancelButton',
  okButton: 'okButton',
}

export default baseColorRepository
